import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum";

import * as appsettings from "../appsettings";
import * as dialog from "../dialog";
import * as main from "../main";
import * as navigation from "../navigation";
import * as viewmode from "../viewmode";

/**
 * Refreshes the grid 
 */
export function refreshGrid(gridname: string): void {

    const grid = $("#" + gridname).data("kendoGrid");

    if (grid != undefined) {
        grid.dataSource.read();
    }
}


/**
* Init (binding button actions)
*/
export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as RoleGridVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("AdministrationRole/Show?roleId=" + dataItem.RoleID + "&breadcrumbLabel=" + dataItem.Label);
}

export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as RoleGridVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("AdministrationRole/Edit?roleId=" + dataItem.RoleID + "&breadcrumbLabel=" + dataItem.Label);
}

export function adaptItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as RoleGridVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("AdministrationRole/Adapt?roleId=" + dataItem.RoleID + "&breadcrumbLabel=" + dataItem.Label);
}

export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    const event = e;
    const data = this;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid): void {
        // Prevent default behaviour 
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as RoleGridVM;
        removeItem(dataItem.RoleID);
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}

export function removeItem(roleId: number): void {
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("AdministrationRole/Delete"),
        data: { roleId: roleId },
        dataType: 'json',
        success: function (responseData: responseModel | undefined | null) {

            refreshGrid("RolesGrid");

            if (responseData != undefined && responseData != null && !responseData.Succesfully) {
                main.makeResultMessage(responseData);
            }
        }
    });
}

export function onChangeModuleRightGranted(e: kendo.ui.CheckBoxChangeEvent): void {
    const checkbox = e.sender.element[0] as HTMLInputElement;
    const [roleId, moduleRightId] = checkbox.name.split("_").map(Number);
    var granted = e.checked;

    $.ajax({
        type: "POST",
        url: appsettings.getUrl("AdministrationRole/Update_RoleModuleRightLevel"),
        data: { roleId: roleId, moduleRightId: moduleRightId, granted: granted },
        dataType: 'json',
        success: function (responseData: responseModel | undefined | null) {
            if (responseData != undefined && responseData != null && !responseData.Succesfully) {
                main.makeResultMessage(responseData);
            }
        }
    });
}
